/**
 * Affiliate Tracking Utility
 * Handles cookie-based referral tracking for the affiliate program
 */

// ALWAYS use current origin for API calls
const API = window.location.origin;
const COOKIE_NAME = 'courtiq_affiliate_ref';
const COOKIE_DAYS = 60; // 60-day attribution window

/**
 * Set a cookie with the given name, value, and expiration days
 */
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

/**
 * Get a cookie value by name
 */
function getCookie(name) {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length);
    }
  }
  return null;
}

/**
 * Check URL for affiliate referral code and track the click
 * Call this on the main marketing pages and auth page
 */
export async function checkAndTrackAffiliateReferral() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const refCode = urlParams.get('ref');
    
    if (!refCode) {
      return null;
    }
    
    // Don't overwrite existing cookie (first-click attribution)
    const existingRef = getCookie(COOKIE_NAME);
    if (existingRef) {
      console.log('Existing affiliate cookie found:', existingRef);
      return existingRef;
    }
    
    // Track the click on the backend
    const response = await fetch(`${API}/api/affiliates/track/${refCode}`);
    const data = await response.json();
    
    if (data.valid) {
      // Set the affiliate cookie
      setCookie(COOKIE_NAME, refCode, data.cookie_days || COOKIE_DAYS);
      console.log('Affiliate referral tracked:', refCode);
      
      // Remove ref from URL for cleaner UX (optional)
      const url = new URL(window.location.href);
      url.searchParams.delete('ref');
      window.history.replaceState({}, '', url.toString());
      
      return refCode;
    }
    
    return null;
  } catch (error) {
    console.error('Error tracking affiliate referral:', error);
    return null;
  }
}

/**
 * Get the stored affiliate referral code from cookie
 */
export function getAffiliateReferralCode() {
  return getCookie(COOKIE_NAME);
}

/**
 * Clear the affiliate referral cookie (e.g., after successful signup)
 */
export function clearAffiliateReferralCode() {
  document.cookie = `${COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}
